import type { FC } from 'react';
import cn from 'classnames';
import times from 'lodash/times';
import { HStack, Stub, VStack } from '@direct-frontend/components';
import styles from './Trigger.module.css';

export type TriggerStubProps = Partial<{
    hasRightIcon: boolean;
    linesCount: number;
}>;

export const TriggerStub: FC<TriggerStubProps> = ({ hasRightIcon, linesCount = 2 }) => (
    <HStack className={cn(styles.trigger, styles.trigger_disabled, styles.triggerStub)}>
        <HStack gap="12" as="span" alignItems="center" className={styles.triggerStack}>
            <Stub height={24} width={24} borderRadius="14" />

            <VStack as="span" gap="2" className={styles.triggerContent} alignItems="stretch">
                {times(linesCount, (index) => (
                    <HStack
                        key={index}
                        alignItems="center"
                        className={styles[lengthClassNames[(index + Number(linesCount === 2)) % 3]]}
                        data-index={index}
                    >
                        <Stub height={8} width="100%" borderRadius="14" />
                    </HStack>
                ))}
            </VStack>

            <HStack gap="8" as="span" alignItems="center">
                {hasRightIcon && <Stub height={24} width={24} borderRadius="14" />}
                <Stub height={16} width={16} borderRadius="14" />
            </HStack>
        </HStack>
    </HStack>
);

const lengthClassNames = ['triggerContentLine80', 'triggerContentLine', 'triggerContentLine60'] as const;
